import React from 'react'
import KFCpin from '../../Assetes/Images/kfc-pin.svg'
import moment from "moment";

export default function StoreItem(props: any) {

    const { store, index } = props;

    return (
        <div className='stor-container' onClick={() => {
            props.setSelectedStore(store);
            props.setZoom(17)
        }}>
            <div className="store-item">
                <img src={KFCpin} alt="" />
                <div>
                    <h5 key={index}>{store?.store_name}</h5>
                    <p>{store?.address}</p>
                    <h5 className='clr-red'><span>{moment(store.store_open_time, ["hh:mm:ss"]).format('hh:mm A')} </span>-<span> {moment(store.store_close_time, ["hh:mm:ss"]).format('hh:mm A')}</span></h5>
                </div>
            </div>
         
        </div>
    )
}
